/**
 * @class
 * @description This class stores information about segments
 * @exports Segment
 */
export default class Segment {
    constructor() {
        this.uri = '';
    }
}
